import { env } from '@/config';

export function injectGTM() {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
  const head = document.getElementsByTagName('head')[0];
  const script = document.createElement('script');

  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${env.VUE_APP_TAG_MANAGER_KEY}`;

  head.appendChild(script);
}

export default class TagManagerHelper {
  static sendPageView(path, title) {
    window.dataLayer.push({
      event: 'pageView',
      pagePath: path,
      pageTitle: title,
    });
  }

  static sendEvent(eventName, eventValue) {
    window.dataLayer.push({
      event: eventName,
      value: eventValue,
    });
  }

  static sendScheduleMetrics(availableIn3Days, availableIn7Days, hoursUntilEarliest) {
    const eventType = 'TherapistScheduleMetrics';
    const label3Days = '3_days_available_slots';
    const label7Days = '7_days_available_slots';
    const labelEarliest = 'hours_until_earliest_available_slot';

    window.dataLayer.push({
      event: eventType,
      label: label3Days,
      value: availableIn3Days,
    });

    window.dataLayer.push({
      event: eventType,
      label: label7Days,
      value: availableIn7Days,
    });

    window.dataLayer.push({
      event: eventType,
      label: labelEarliest,
      value: hoursUntilEarliest,
    });
  }
}
